import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyManagement = lazy(() => import('pages/Management'));
const LazyManagementForm = lazy(() => import('pages/ManagementForm'));
const LazyManagementDetail = lazy(() => import('pages/ManagementDetail'));

function ManagementRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyManagement />} />
        <Route path="/form/:user_id?" element={<LazyManagementForm />} />
        <Route path="/detail/:user_id" element={<LazyManagementDetail />} />
      </Routes>
    </Suspense>
  );
}

export default ManagementRoute;
